module.exports = __webpack_public_path__ + "img/task-note-today.ee8f929d.svg";